<template>
    <div class="right">
        <ul class="hidden-xs-only">
            <li>
                <div class="mains">
                    <i class="iconfont icon-qq"></i>
                </div>
                <div class="left">
                    <div class="top">QQ在线咨询</div>
                    <a href="tencent://message/?uin=935856611&Site=&Menu=yes">
                        <i class="iconfont icon-qq"></i>
                        <span>在线客服</span>
                     </a>
                    <a href="tencent://message/?uin=926139895&Site=&Menu=yes">
                        <i class="iconfont icon-qq1"></i>
                        <span>售后客服</span>
                     </a>
                </div>
            </li>
            <li>
                <div class="mains">
                    <i class="iconfont icon-dianhua"></i>
                </div>
                <div class="left">
                    <div>40083 66685</div>
                </div>
            </li>
            <li>
                <div class="mains">
                    <i class="iconfont icon-weixin2"></i>
                </div>
                <div class="left">
                    <img src="~@/assets/images/ewm.jpeg" alt="" />
                </div>
            </li>
            <li @click="goTop">
                <div class="mains">
                    <i class="iconfont icon-jiantoushang"></i>
                </div>
            </li>
        </ul>
        <!-- <div class="phone hidden-sm-and-up">
            <a href="tel:19951358899">
                咨询电话
            </a>
        </div> -->
    </div>
</template>
<script>
    export default {
        name: '',
        data() {
            return {
                scrollTop:'',
                topValue:''
            }
        },
        watch:{
            // scrollTop(){
            //     return this.topValue=this.scrollTop+(window.innerHeight/2)
            // }
        },
        created(){
        },
        mounted(){
            // window.addEventListener('scroll',setTimeout(this.handleScroll,2000))
        },
        methods:{
            // handleScroll() {
            //     this.scrollTop =
            //         window.pageYOffset ||
            //         document.documentElement.scrollTop ||
            //         document.body.scrollTop;
            // },
            goTop() {
                let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                let timer = null,
                    _that = this;
                window.cancelAnimationFrame(timer);
                timer = window.requestAnimationFrame(function fn() {
                    if (scrollTop > 0) {
                        scrollTop -= 50;
                        document.body.scrollTop = document.documentElement.scrollTop =
                            scrollTop;
                        timer = window.requestAnimationFrame(fn);
                    } else {
                        window.cancelAnimationFrame(timer);
                    }
                });
            }
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        }
    }
</script>
<style scoped>
.right ul {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-30%);
  z-index: 9999;
}

.right ul li {
  position: relative;
  border-bottom: 2Px solid #3197f0;
  background: #2c88d8;
	display: flex;
	align-items: center;
	justify-content: center;
}

.right ul li .mains {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right ul li .mains .iconfont {
  color: white;
  font-size: 28px;
}

.right ul li .left {
  display: none;
  width: 200px;
  position: absolute;
  top: 0;
  right: 80px;
  background: #f9f9f9;
  box-shadow: -5px 0 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.right ul li:hover .left {
  display: block;
}

.right ul li:nth-child(1) {
  border-top-left-radius: 5px;
}

.right ul li:nth-child(1) .left .top {
  font-size: 22px;
  text-align: center;
  padding: 15px 0;
  background: white;
  color: #0185da;
}

.right ul li:nth-child(1) .left a {
  display: block;
  margin: 15px 20px;
  padding: 10px 20px;
  border-bottom: 1px solid #dedede;
	color: #333;
}

.right ul li:nth-child(1) .left a span {
  font-size: 16px;
  margin-left: 15px;
}

.right ul li:nth-child(2) div {
  height: 60px;
  line-height: 60px;
  padding: 0 10px;
  font-size: 24px;
  font-weight: bold;
  color: #217cc8;
}

.right ul li:nth-child(3) .left {
  transform: translateY(-30%);
}

.right ul li:nth-child(3) img {
  width: 100%;
}

.right ul li:nth-child(4) {
  border-bottom-left-radius: 5px;
}

.right .phone {
  width: 100%;
  height: 50px;
  position: fixed;
  right: 0;
  bottom: 0;
  background: #207dc7;
  text-align: center;
  line-height: 50px;
}

.right .phone a {
  color: white;
  font-size: 20px;
  letter-spacing: 15px;
}

</style>


// WEBPACK FOOTER //
// src/components/side/index.vue